export enum TransferSituation{
	GERADA = 'gerada',
	AGENDADA = 'agendada',
	PENDENTE = 'pendente',
	AUTORIZADA_PENDENTE = 'autorizadapendente',
	AGUARDANDO_ANALISE_ANTIFRAUDE = 'aguardandoAnaliseAntifraude',
	CANCELADA_ANTIFRAUDE = 'canceladaAntifraude'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/models/transferSituation.ts